import { BIFROST_ENABLED_LOCALES } from '@99designs/design-services-common';
import { __image, __url } from '@99designs/i18n';
import { buildCloudinaryURL } from '../../components/CloudinaryImage';
import type { SupportedLocale } from '@99designs/i18n';
import type { DesignProduct, DesignProductPresenter, ProductImageOptions } from './types';

export const NewDesignProductPresenter = (designProduct: DesignProduct) => {
    return {
        ...designProduct,
        ctaUrl(locale: SupportedLocale, crossPlatformTracking?: URLSearchParams) {
            if (isNNLogoEssential(designProduct, locale)) {
                return buildHref(__url('/logo-design'), crossPlatformTracking);
            }

            return buildHref(`/design/get-started?mpvId=${designProduct.mpvId}&locale=${locale}`);
        },
        previewImage(options?: ProductImageOptions) {
            return {
                url: buildCloudinaryURL(
                    __image(`PreviewImages/${designProduct.mpvId}`),
                    options?.cloudinaryOptions
                ),
                aspectRatio: 0.75,
            };
        },
    } as DesignProductPresenter;
};

const buildHref = (ctaLink: string, crossPlatformTracking?: URLSearchParams) => {
    if (!crossPlatformTracking) {
        return ctaLink;
    }

    const url = new URL(ctaLink, 'https://vistaprint.com');
    const newCtaLink = ctaLink.replace(url.search, '');

    crossPlatformTracking.forEach((value, key) => {
        url.searchParams.set(key, value);
    });

    return newCtaLink + url.search;
};

export const isNNLogoEssential = (designProduct: DesignProduct, locale: SupportedLocale) => {
    return designProduct.mpvId === 'logoEssential' && !BIFROST_ENABLED_LOCALES.includes(locale);
};
